<div [formGroup]="formGroup" class="mb-1">
  <div class="d-flex justify-content-arround row" *ngIf="showError">
    <div [ngClass]="hasError()?'col-6':'col-12'" *ngIf="label">
      <label for="example-email" class="form-label">{{ label }}<span *ngIf="isRequired"> * </span></label>
    </div>
    <!-- <div [ngClass]="hasError()?'col-6':'col-12'" *ngIf="showError">
      <div *ngIf="hasError()" class="invalid-feedback d-block text-end">{{ getErrorMessage() }}</div>
      <div *ngIf="isValid()" class="valid-feedback d-block text-end">Looks good!</div>
    </div> -->
  </div>

  <ng-container *ngIf="enableMentions; else plainTextarea">
    <textarea
      id="example-textarea"
      [mention]="mentionItems"
      [mentionConfig]="{ labelKey: 'name', triggerChar: '@', dropUp: true }"
      [rows]="rows"
      [name]="formName"
      [formControlName]="formControlValue"
      [placeholder]="placeholder"
      class="form-control"
      [maxlength]="maxlength"
      [ngClass]="{
        'is-invalid': hasError(),
        'bg-light': isReadonly,
        'is-valid': isValid(),
        'text-muted': isReadonly,
        'opacity-75': isReadonly
      }"
      [readonly]="isReadonly"
      [attr.tabindex]="isReadonly ? -1 : null"
      [attr.aria-disabled]="isReadonly ? true : null"
      [ngStyle]="{ 'background-color': backgroundColor }"
    ></textarea>
  </ng-container>

  <ng-template #plainTextarea>
    <textarea
      id="example-textarea"
      [rows]="rows"
      [name]="formName"
      [formControlName]="formControlValue"
      [placeholder]="placeholder"
      class="form-control"
      [maxlength]="maxlength"
      [ngClass]="{
        'is-invalid': hasError(),
        'bg-light': isReadonly,
        'is-valid': isValid(),
        'text-muted': isReadonly,
        'opacity-75': isReadonly
      }"
      [readonly]="isReadonly"
      [attr.tabindex]="isReadonly ? -1 : null"
      [attr.aria-disabled]="isReadonly ? true : null"
      [ngStyle]="{ 'background-color': backgroundColor }"
    ></textarea>
  </ng-template>
</div>
